/**
 * Whether a supplier emission rate (kgCO2e/kWh, the market-based rate for a record or location) has
 * been given. 0 is a real rate, a 100% renewable tariff, so this tests for presence: a truthiness test
 * read a 0 rate as "no rate", hid it in the form and refused to save it.
 */
export const hasSupplierRate = (value: unknown): boolean =>
  value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value))
